import { theme } from '~/theme'

export function Loading({ label }: { label: string }) {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 18,
        background: theme.bg,
        color: theme.textDim,
      }}
    >
      <div
        style={{
          width: 14,
          height: 14,
          background: theme.terracotta,
          animation: 'go-pulse 0.9s steps(2, end) infinite',
        }}
      />
      <div style={{ fontSize: 14, letterSpacing: 0.3 }}>{label}</div>
      <style>{`@keyframes go-pulse { 0%,100% { opacity: 1 } 50% { opacity: 0.25 } }`}</style>
    </div>
  )
}
